import {
    Component, OnInit, Input, ViewChild, AfterViewInit, ChangeDetectorRef,
    ChangeDetectionStrategy, Output, EventEmitter, ElementRef,
    Renderer2, Injector, LOCALE_ID, Optional, InjectFlags, OnDestroy, NgZone
} from '@angular/core';
import { FieldConfig } from './entity/fieldconfig/fieldconfig';
import { QueryCondition } from './entity/querycondition';
import { ControlType } from './entity/controltype';
import { ListFilterService } from './service/list-filter.service';
import { QuerySolutionService } from './submithandlers/query-solution.service';
import { ConvertorService } from './service/convertorservice';
import { TextValue } from './entity/conditionvalue/textvalue';
import { HelpValue } from './entity/conditionvalue/helpvalue';
import { DropDownListValue } from './entity/conditionvalue/dropdownlistvalue';
import { DateRangeValue } from './entity/conditionvalue/daterangevalue';
import { NumberRangeValue } from './entity/conditionvalue/numberrangevaue';
import { SearchValue } from './entity/conditionvalue/searchvalue';
import { DateValue } from './entity/conditionvalue/datevalue';
import { CheckboxGroupValue } from './entity/conditionvalue/checkboxgroupvalue';
import { DateRangeTimeValue } from './entity/conditionvalue/daterangetimevalue';
import { ListFilterHandler, LISTFILTER_HANDLER_TOKEN } from './interface/IistFilterHandler';
import { RadioGroupValue } from './entity/conditionvalue/radiovalue';
import { MonthValue } from './entity/conditionvalue/month';
import { YearValue } from './entity/conditionvalue/yearvalue';
import { YearRangeValue } from './entity/conditionvalue/yearrange';
import { MonthRangeValue } from './entity/conditionvalue/monthrange';
import { InputGroupValue } from './entity/conditionvalue/inputgroup';
import { IdService, OverLayHiddenService } from '@farris/ui-common';
import { LocaleService } from '@farris/ui-locale';
import ResizeObserver from "resize-observer-polyfill";
import { ComboLookUpValue } from './entity/conditionvalue/combolookupvalue';
@Component({
    selector: 'farris-list-filter',
    templateUrl: './list-filter.component.html',
    styleUrls: ['./list-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListFilterComponent implements OnInit, AfterViewInit,OnDestroy {

    @ViewChild('filterMainBasis') filterMainBasisRef: ElementRef;
    @ViewChild('floatPanel') floatPanel: ElementRef;
    @ViewChild('listFilterContainer') listFilterContainerRef: ElementRef;
    //  表单左对齐
    @Input() alLeft = false;
    //  平分空间
    @Input() autoWidth = true;
    //  实时搜索
    @Input() liveSearch = false;
    //  label的宽度是否自适应
    @Input() autoLabel = false;
    //  是否禁用
    @Input() disabled = false;

    @Input() filterClass: string;
    @Input() filterPaddingNone = false;
    // 筛选展示类型 list 一行展示，其他如果autoWidth为true 一行内展示，如果autoWidth为false 表格式展示
    @Input() filterType: string;
    // 初始化值
    _defaultValue: FieldConfig[];
    // 默认值是空值时执行查询，兼容旧方式
    @Input() defaultEmptyValueSearch=true;
    @Input()
    set defaultValue(configs: FieldConfig[]) {
        this._defaultValue = configs;
        let canFilter=this.defaultEmptyValueSearch||configs&&configs.length>0;
        if(canFilter){
            setTimeout(() => {
                this.setFilterValue(this._defaultValue);
            });
        }
    }
    get defaultValue() {
        return this._defaultValue;
    }
    // 按钮位置 top顶部 bottom 底部
    @Input() buttonPosition: string = 'top';
    // 查询按钮文本
    @Input() filterText: string = '';
    // 清空按钮文本
    @Input() clearButtonText: string='';
    @Output() query = new EventEmitter();
    @Output() clear = new EventEmitter();
    @Output() searchChange = new EventEmitter();
    @Output() conditionsChange = new EventEmitter();

    filterDatas: Array<FieldConfig>;
    //  filterWidth:number = 1000;
    //  标记是否有滚动条
    //  hasScroll = true;
    //  需要监听收折的表单
    //  resizeGroups: listFilterGroup;
    // 筛选icon部分小红点
    showExpandTag = false;
    //  响应式容器
    //  @ViewChild('resizedContainer') resizedContainerEl;
    //  响应式内容容器
    //  @ViewChild('resizedContent') resizedContentEl;
    //  @ViewChild('resizeLists') resizeListsEl;
    //  @ViewChild('simulateExtend') simulateExtendEl;

    //  @ViewChild('resizedContainer', { read: FResizedDirective })
    //  resizedContainerDirective: FResizedDirective;

    /** 搜索表单列表 */
    _filterList: Array<any>;

    /** 是否需要显示展开更多icon */
    showMoreIcon = false;
    //  moreIconWidth:number = 0;
    showFilter = false;
    // 是否展现出的只有一个搜索控件
    formExpand = false;
    // 提交表单数据
    //  queryList;
    // 隐藏提交表单数据
    //  extendqueryList;
    /** 循环表单 */
    listFilterConditions: Array<QueryCondition> = new Array<QueryCondition>();
    /** 用来存储setvalue前数据 */
    stagListFilterConditions: Array<QueryCondition> = new Array<QueryCondition>();
    /** 记录默认收起的搜索表单列表 */
    extendFilterList: Array<QueryCondition> = [];
    /** 记录显示的搜索表单列表 */
    showFilterList: Array<QueryCondition> = [];
    /** 显示中表单的必填项 */
    requiredListFilter: Array<QueryCondition> = [];
    /** 隐藏中表单的必填项 */
    //  extendRequiredListFilter: Array<QueryCondition> = [];
    /** 表单是否允许提交 */
    canSubmit = false;
    /** 扩展表单是否允许提交 */
    //  extendCanSubmit:boolean = false;

    localeIds = {
        en: 'en',
        'zh-CHS': 'zh-CHS'
    };
    currentLocale = 'zh-CHS';
    @Input() isControlInline = true;

    @Input()
    get filterList(): Array<any> {
        return this._filterList;
    }
    set filterList(filterList: Array<any>) {
        this._filterList = filterList;
        this.initFilterList();
    }
    /**
     * 初始是否收起
     */
    expandedState = false;
    private pInitExpanded = false;
    // 是否需要显示收折按钮
    showExpandButton=false;
    // 扩展按钮对齐方向
    expandButtonAlign='right';
    // 在类成员变量中添加防抖定时器
    private resizeTimer: any = null
    /**
     * 展开状态
     */
    @Input() 
    set expandStatus(value:boolean){
        this.pInitExpanded = value;
        this.expandedState = value;
    }
    get expandStatus():boolean{
        return this.pInitExpanded;
    } 

    /**
     * 组件服务接口
     */
    listfilterHandler: ListFilterHandler;
    
    fieldCodeOfClearFields: Array<string> = [];
    private localeService: LocaleService;
    private idService: IdService;
    UPDATE_FILTER_VALUES_TIMER = null;
    private overLayService: OverLayHiddenService = null;
    // 绑定大小变化响应
    private ro: ResizeObserver | null = null;
    private ngZone: NgZone;
    private itemsContainer: HTMLElement=null;
    constructor(
        private filterService: ListFilterService,
        private cd: ChangeDetectorRef,
        private handler: QuerySolutionService,
        private convertorService: ConvertorService,
        private render: Renderer2,
        @Optional() private injector: Injector,
    ) {
        if (this.injector) {
            this.currentLocale = this.injector.get(LOCALE_ID);
            this.listfilterHandler = this.injector.get<ListFilterHandler>(LISTFILTER_HANDLER_TOKEN, null, InjectFlags.Optional);
            this.idService = this.injector.get(IdService);
            this.overLayService = this.injector.get(OverLayHiddenService, null);
            this.localeService = this.injector.get(LocaleService);
            this.ngZone = this.injector.get(NgZone);
        }
        if (!this.overLayService) {
            this.overLayService = new OverLayHiddenService();
        }
    }

    ngOnInit() {
        // if (this.currentLocale === this.localeIds['en']) {
        //     this.isControlInline = false;
        // } else {
        //     this.isControlInline = true;
        // }
        if (!this.filterText||this.filterText.trim() === '筛选' || this.filterText.trim() === '篩選') {
            this.filterText = this.localeService.getValue('listFilter.filter');
        }

        if (!this.clearButtonText||this.clearButtonText.trim() === '清空') {
            this.clearButtonText = this.localeService.getValue('listFilter.clear');
        }
        this.canShowMoreIcon();
        this.itemsContainer = this.listFilterContainerRef?this.listFilterContainerRef.nativeElement.querySelector('.filter-inputs-main')as HTMLElement:null;
        this.bindRoEvent();
    }

    ngAfterViewInit() {
        if (this.autoWidth && !this.formExpand && this.filterMainBasisRef) {
            const basicList = this.filterMainBasisRef.nativeElement.querySelectorAll('.filter-input-list');
            let basicWidth = 0;
            if (basicList && basicList.length) {
                for (let k = 0; k < basicList.length; k++) {
                    const offW = Math.ceil(parseFloat(basicList[k].offsetWidth || 0));
                    if (offW > 0) {
                        basicWidth += offW;
                    }
                }
            }
            if (basicWidth > 0) {
                this.render.setStyle(this.filterMainBasisRef.nativeElement, 'width', basicWidth + 'px');
            }
        }
        this.showExpandButton=this.canShowExpandButton();
        this.handleInitExpandedState();
        this.setExpandButtonAlign();
    }
     /**
     * 绑定监控大小的事件
     */
     private bindRoEvent(){
        if(this.buttonPosition!=='bottom'){
            return;
        }
        if(!this.itemsContainer||!this.ngZone){
            return;
        }
        const self=this;
        this.ngZone.runOutsideAngular(() => {           
            self.ro = new ResizeObserver((entries, observer) => {
                self.resizeTimer = setTimeout(() => {
                    self.ngZone.run(() => {
                        const tempHeight = entries[0].contentRect.width;
                        if(tempHeight<=0){
                            return;
                        }
                        self.handleResize();
                    });
                }, 100); 
            });
            self.ro.observe(self.itemsContainer);
        });
    }
    /**
     * 处理窗口大小变化
     */
    private handleResize() {
        // 1. 临时显示所有条件以便测量
        this.listFilterConditions.forEach(c => {
            if (!c.control.isExtend && c.visible !== false) {
                c.shown = true;
            }
        });
        this.cd.detectChanges();

        // 2. 判断是否需要显示展开按钮（此时所有条件都已渲染）
        const shouldShowExpandButton = this.canShowExpandButton();
        
        if (this.showExpandButton !== shouldShowExpandButton) {
            this.showExpandButton = shouldShowExpandButton;
            this.setExpandButtonAlign();
        }

        // 3. 根据状态设置 shown
        if (this.showExpandButton) {
            if (!this.expandedState) {
                // 收起状态：updateFilterItemsVisibility 内部会重新计算并设置 shown
                this.updateFilterItemsVisibility();
                return; // updateFilterItemsVisibility 内部会 detectChanges
            }
        }
        // 不需要展开按钮或处于展开状态：所有条件可见（已设置 shown = true）
        this.cd.detectChanges();
    }
    /**
     * 设置收折按钮的方向
     * @returns 
     */
    private setExpandButtonAlign(){
        if(this.buttonPosition!=='bottom'){
            return;
        }
        if(this.showExpandButton){
            const container = this.listFilterContainerRef.nativeElement.querySelector('.filter-inputs-main');
            const firstItem = container.querySelector(".list-filter--item")as HTMLElement; 
            const footerButtons = container.querySelector(".filter-inputs-footer--buttons") as HTMLElement; 
            const firstRect = firstItem.getBoundingClientRect();
            const lastRect = footerButtons.getBoundingClientRect();   
            this.expandButtonAlign=Math.abs(firstRect.top - lastRect.top) < 5?'left':'right';
        }else{
            this.expandButtonAlign='right';
        }
    }
   /** 
     * 判断是否显示展开按钮
     * 调用前需确保所有条件已设为 shown=true 并已渲染
     */
    private canShowExpandButton():boolean {
        if(this.buttonPosition !== 'bottom'){
            return false;
        }
            if(this.filterType !== 'list'&&this.autoWidth){
                return false;
            }
            if(!this.itemsContainer){
                return false;
            }

            const itemsNodeList =this.itemsContainer.querySelectorAll(".list-filter--item");
            // 不存在条件
            if(!itemsNodeList  || itemsNodeList .length < 2){
                return false;
            }    
            const items = Array.from(itemsNodeList) as HTMLElement[];

            // 使用 getBoundingClientRect 判断首尾是否在同一行
            const firstItem = items[0];
            const lastItem = items[items.length - 1];
            
            // 防御性编程：确保元素存在且可见
            if (!firstItem || !lastItem) return false;

            const firstRect = firstItem.getBoundingClientRect();
            const lastRect = lastItem.getBoundingClientRect();
            
            // 如果高度为0，说明元素仍然不可见（可能被父级隐藏或其他原因），此时无法判断
            if (firstRect.height === 0 || lastRect.height === 0) {
                 return false; 
            }
            const isSameRow = Math.abs(firstRect.top - lastRect.top) < 5;
            
            return !isSameRow; // 不在同一行，则需要展开按钮
    }
    /** 处理初始展开按钮状态 */
    private handleInitExpandedState(){ 
        this.expandedState =this.showExpandButton?this.pInitExpanded:true;
        if(!this.expandedState){
            // 收起状态
           this.updateFilterItemsVisibility();
        }
    }
    /**
     * 根据展开状态更新表单项的可见性
     * 如果收起，则计算一行能放下的元素，其余设置 shown=false
     * 如果展开，则所有条件 shown=true
     */
    private updateFilterItemsVisibility() {
        if (!this.listFilterContainerRef || !this.itemsContainer) {
            return;
        }

        if (!this.listFilterConditions || this.listFilterConditions.length === 0) {
            return;
        }

        // 获取非扩展、可见的条件列表（与模板 *ngIf 条件一致）
        const displayConditions = this.listFilterConditions.filter(c => !c.control.isExtend && c.visible !== false);

        // 如果处于展开状态，显示所有项
        if (this.expandedState) {
            displayConditions.forEach(c => c.shown = true);
            this.cd.detectChanges();
            return;
        }

        // --- 收起状态下的计算逻辑 ---
        // 1. 临时设置所有条件为可见，以便获取真实宽度
        displayConditions.forEach(c => c.shown = true);
        this.cd.detectChanges();

        // 2. 获取DOM元素进行测量
        const items = Array.from(this.itemsContainer.querySelectorAll(".list-filter--item")) as HTMLElement[];
        const footerButtons = this.itemsContainer.querySelector(".filter-inputs-footer--buttons") as HTMLElement;

        if (!items || items.length === 0) {
            return;
        }

        // 3. 强制重排，确保宽度计算准确
        void this.itemsContainer.offsetWidth;

        // 4. 获取容器和按钮宽度
        const containerWidth = this.itemsContainer.offsetWidth;
        const buttonsWidth = footerButtons ? footerButtons.offsetWidth : 0;
        const availableWidth = containerWidth - buttonsWidth;

        let currentLineWidth = 0;
        let hideIndex = -1;

        // 5. 遍历计算
        for (let i = 0; i < items.length; i++) {
            const itemWidth = items[i].offsetWidth;
            if (currentLineWidth + itemWidth > availableWidth) {
                hideIndex = i;
                break;
            } else {
                currentLineWidth += itemWidth;
            }
        }

        // 6. 设置 shown 属性（映射回 displayConditions）
        if (hideIndex !== -1) {
            let j = hideIndex == 0 ? 1 : hideIndex;
            for (; j < displayConditions.length; j++) {
                displayConditions[j].shown = false;
            }
        }

        this.cd.detectChanges();
    }
 
    ngOnDestroy(){
        if (this.floatPanel) {
            this.overLayService.destory(this.floatPanel.nativeElement);
        }
        if (this.ro) {
            this.ro.unobserve(this.itemsContainer);
            this.ro = null;
        }
        if (this.resizeTimer) {
            clearTimeout(this.resizeTimer);
        }
    }
    /** 初始化处理表单数据 */
    initFilterList() {
        this.listFilterConditions = new Array<QueryCondition>();
        this.extendFilterList = [];
        this.showFilterList = [];
        this.filterDatas = this.filterService.fieldSchemasConvert(this._filterList);
        if (this.filterDatas && this.filterDatas.length) {
            this.listFilterConditions = this.convertorService.getSelectedFieldConditions(this.filterDatas, this.listFilterConditions);
            this.stagListFilterConditions = this.listFilterConditions.map(o => ({ ...o }));
            // 存储扩展项和默认展示表单
            this.listFilterConditions.forEach(field => {
                if (field.control.isExtend) {
                    this.extendFilterList.push(field);
                } else {
                    this.showFilterList.push(field);
                }
            });
            // 判断是否是左对齐 只有一个搜索
            const _basisFilterList = this.listFilterConditions.filter((field) => {
                return !field.control.isExtend;
            })
            if (_basisFilterList && _basisFilterList.length === 1 && this.getControlType(_basisFilterList[0]) === 'search') {
                this.formExpand = true;
            }
            this.conditionChangeHandler();
            this.inSetCurrentFilterConditions();
            // 重置 shown 状态
            this.listFilterConditions.forEach(c => c.shown = true);
            // 存储默认展示中必填项
            this.requiredListInit();
            this.canShowMoreIcon();
            //  this.listSearch();
            this.cd.detectChanges();
        }
    }

    inSetCurrentFilterConditions() {
        if (this.listfilterHandler) {
            this.listfilterHandler.setCurrentFilterConditions(this.listFilterConditions);
        }
    }


    /**
     * 获取控件类型
     * @param selectedFieldCondition
     */
    getControlType(selectedFieldCondition: QueryCondition): string {
        if (selectedFieldCondition) {
            if (selectedFieldCondition.control.getControlType() == ControlType.Text) {
                return 'input';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.Search) {
                return 'search';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.Date) {
                return 'date';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.Month) {
                return 'month';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.Year) {
                return 'year';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.DateRange) {
                return 'daterange';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.DateRangeTime) {
                return 'daterangetime';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.MonthRange) {
                return 'monthrange';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.YearRange) {
                return 'yearrange';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.DropDown) {
                return 'dropdown';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.NumberRange) {
                return 'number';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.Help) {
                return 'help';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.CheckboxGroup) {
                return 'checkboxgroup';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.Radio) {
                return 'radio';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.InputGroup) {
                return 'input-group';
            } else if (selectedFieldCondition.control.getControlType() == ControlType.ComboLookUp) {
                return 'combolist-help';
            } else {
                return 'input';
            }
        }

    }
    /** 获得类名 */
    getStyle(currentItem: any): string {
        const defaultCondtionStyle = 'col-12 col-md-6 col-xl-3 col-el-2';
        return (this.filterClass && !this.autoWidth) ? this.filterClass : defaultCondtionStyle;
    }

    /** 判断是否需要显示更多按钮 */
    canShowMoreIcon() {
        if (this.extendFilterList.length > 0) {
            this.showMoreIcon = true;
        } else {
            this.showMoreIcon = false;
        }
    }

    /** 判断是否所有必填项都填写完毕 */
    canSubmitFilter(requirelist) {
        let formCanSubmit = false;
        if (!requirelist || !requirelist.length) {
            formCanSubmit = true;
            return formCanSubmit;
        } else {
            for (let i = 0; i < requirelist.length; i++) {
                const item = requirelist[i];
                if (item.control.getControlType() === ControlType.Text) {
                    const tv = (item.value as TextValue);
                    if (Object.keys(tv).length < 0 || !tv.value) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.Help) {
                    const shv = (item.value as HelpValue);
                    if (Object.keys(shv).length === 0 || !shv.value || !shv.valueField) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.DropDown) {
                    const ddv = (item.value as DropDownListValue);
                    if (Object.keys(ddv).length === 0 || !ddv.value) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.DateRange) {
                    const drv = (item.value as DateRangeValue);
                    if (Object.keys(drv).length === 0 || (!drv.startTime && !drv.endTime)) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.DateRangeTime) {
                    const drv = (item.value as DateRangeTimeValue);
                    if (Object.keys(drv).length === 0 || (!drv.startTime && !drv.endTime)) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.MonthRange) {
                    const mrv = (item.value as MonthRangeValue);
                    if (Object.keys(mrv).length === 0 || (!mrv.startTime && !mrv.endTime)) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.YearRange) {
                    const yrv = (item.value as YearRangeValue);
                    if (Object.keys(yrv).length === 0 || (!yrv.startTime && !yrv.endTime)) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.NumberRange) {
                    const nrv = (item.value as NumberRangeValue);
                    if (Object.keys(nrv).length === 0 || (!nrv.startValue && !nrv.endValue)) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.Search) {
                    const sv = (item.value as SearchValue);
                    if (Object.keys(sv).length < 0 || !sv.value) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.Date) {
                    const dv = (item.value as DateValue);
                    if (Object.keys(dv).length < 0 || !dv.value) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.Month) {
                    const mv = (item.value as MonthValue);
                    if (Object.keys(mv).length < 0 || !mv.value) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.Year) {
                    const yv = (item.value as YearValue);
                    if (Object.keys(yv).length < 0 || !yv.value) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.CheckboxGroup) {
                    const cbgv = (item.value as CheckboxGroupValue);
                    if (Object.keys(cbgv).length === 0 || Object.keys(cbgv.value).length === 0) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.Radio) {
                    const ddv = (item.value as RadioGroupValue);
                    if (Object.keys(ddv).length === 0 || !ddv.value) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.InputGroup) {
                    const sv = (item.value as InputGroupValue);
                    if (Object.keys(sv).length < 0 || !sv.textValue) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                } else if (item.control.getControlType() === ControlType.ComboLookUp) {
                    const clv = (item.value as ComboLookUpValue);
                    if (!clv.value || !clv.value.length || !clv.valueField) {
                        formCanSubmit = false;
                        return false;
                    } else {
                        formCanSubmit = true;
                    }
                }

            }
            return formCanSubmit;
        }
    }
    /** 搜索表单变化 */
    onSearch($event, item) {
        if (this.disabled) { return; }
        this.conditionChangeHandler(false);
        this.searchChange.emit({ item, conditions: this.listFilterConditions, instance: this});
        this.inSetCurrentFilterConditions();
        this.canSubmit = this.canSubmitFilter(this.requiredListFilter);
        if (item.control.isExtend || !this.canSubmit || !this.liveSearch) {
            return;
        }
        this.submit('showFormData', this.listFilterConditions);
    }
    /** 开始筛选 */
    filterClick() {
        if (this.disabled || !this.canSubmit) { return; }
        this.submit('showFormData', this.listFilterConditions);
    }
    /** 收折部分点击确定提交 */
    listSearch() {
        if (this.disabled || !this.canSubmit) { return; }
        this.showFilter = false;
        this.submit('extendFormData', this.listFilterConditions);
    }
    /** 取消搜索 */
    listSearchCancel() {
        this.showFilter = false;
    }
    /** 提交表单 */
    submit(type, filterlist) {
        let queryList;
        queryList = this.handler.setFilterConditions(filterlist);
        if (type == 'extendFormData') {
            if (queryList.length > 0) {
                this.showExpandTag = true;
            }
            else {
                this.showExpandTag = false;
            }
        }
        this.query.emit({ type, data: JSON.stringify(queryList) });
    }
    /** 对外提供获得表单搜索数据 */
    getFilterData() {
        let queryList;
        queryList = this.handler.setFilterConditions(this.listFilterConditions);
        return JSON.stringify(queryList);
    }
    /** 获取展示在外部的表单长度 */
    getShowLength() {
        if (this.showFilterList) {
            return this.showFilterList.length;
        }
    }
    /** 清空条件 */
    resetSearch() {
        if (this.disabled) { return; }
        if (this.listFilterConditions && this.listFilterConditions.length) {
            this.listFilterConditions.forEach(listFilterCondition => {
                if (listFilterCondition.control.getControlType() == ControlType.Text) {
                    listFilterCondition.value = new TextValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.Search) {
                    listFilterCondition.value = new SearchValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.Date) {
                    listFilterCondition.value = new DateValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.Month) {
                    listFilterCondition.value = new MonthValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.Year) {
                    listFilterCondition.value = new YearValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.DateRange) {
                    listFilterCondition.value = new DateRangeValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.MonthRange) {
                    listFilterCondition.value = new MonthRangeValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.YearRange) {
                    listFilterCondition.value = new YearRangeValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.DropDown) {
                    listFilterCondition.value = new DropDownListValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.NumberRange) {
                    listFilterCondition.value = new NumberRangeValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.Help) {
                    listFilterCondition.value = new HelpValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.CheckboxGroup) {
                    listFilterCondition.value = new CheckboxGroupValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.Radio) {
                    listFilterCondition.value = new RadioGroupValue();
                } else if (listFilterCondition.control.getControlType() == ControlType.InputGroup) {
                    listFilterCondition.value = new InputGroupValue();
                }else if(listFilterCondition.control.getControlType() == ControlType.ComboLookUp){
                    listFilterCondition.value = new ComboLookUpValue();
                }else {
                    listFilterCondition.value = new TextValue();
                }
            });
            //  let listFilter = this.listFilterConditions.map(o => Object.assign({}, o));
            const listFilter = this.listFilterConditions.map(o => ({ ...o }));
            this.listFilterConditions = listFilter;
            this.stagListFilterConditions=this.listFilterConditions.map(o => ({ ...o }));
            this.requiredListInit();
            //  this.cd.markForCheck();
        }
        this.conditionChangeHandler(false);
        this.clear.emit();
    }

    /**
     * 设置条件的可见性
     * @param visibilityConfigs 条件可见性配置数组，如 [{labelCode: 'xxx', visible: false}]
     * 隐藏条件时会自动清空该条件的值
     */
    setConditionVisibility(visibilityConfigs: Array<{ labelCode: string; visible: boolean }>) {
        if (!visibilityConfigs || !visibilityConfigs.length) {
            return;
        }
        if (this.listFilterConditions && this.listFilterConditions.length) {
            visibilityConfigs.forEach(config => {
                const condition = this.listFilterConditions.find(c => c.fieldCode === config.labelCode);
                if (condition) {
                    condition.visible = config.visible;
                    // 隐藏时清空该条件的值
                    if (!config.visible && condition.value && typeof condition.value.clearValue === 'function') {
                        condition.value.clearValue();
                    }
                }
            });
            // 触发变更检测
            this.listFilterConditions = this.listFilterConditions.map(o => ({ ...o }));
            this.cd.detectChanges();
        }
    }

    // 设置默认值
    setFilterValue(fieldConfigs: FieldConfig[]) {

        if (this.UPDATE_FILTER_VALUES_TIMER) {
            clearTimeout(this.UPDATE_FILTER_VALUES_TIMER);
        }

        this.UPDATE_FILTER_VALUES_TIMER = setTimeout(() => {

            const _filters = this.stagListFilterConditions.map(o => ({ ...o }));
            if (_filters && _filters.length) {
                this.setValues(_filters, fieldConfigs);
                const listFilter = _filters.map(o => ({ ...o }));
                this.listFilterConditions = listFilter;
                this.requiredListInit();
                this.conditionChangeHandler();
                this.inSetCurrentFilterConditions();
                //  this.listSearch();
                this.cd.detectChanges();
                this.cd.markForCheck();
                this.canSubmit = this.canSubmitFilter(this.requiredListFilter);
                if (!this.canSubmit) {
                    return;
                }
                this.submit('showFormData', this.listFilterConditions);
            }
        });


        // this.listFilterConditions = this.stagListFilterConditions.map(o => ({ ...o }));
        // if (this.listFilterConditions && this.listFilterConditions.length) {
        //     this.setValues(this.listFilterConditions, fieldConfigs);
        //     const listFilter = this.listFilterConditions.map(o => ({ ...o }));
        //     this.listFilterConditions = listFilter;
        //     this.requiredListInit();
        //     this.searchChange.emit(this.listFilterConditions);
        //     this.inSetCurrentFilterConditions();
        //     //  this.listSearch();
        //     this.cd.detectChanges();
        //     this.cd.markForCheck();
        //     this.canSubmit = this.canSubmitFilter(this.requiredListFilter);
        //     if (!this.canSubmit) {
        //         return;
        //     }
        //     this.submit('showFormData', this.listFilterConditions);
        // }
    }
    // 设置value
    setValues(conditions, fieldConfigs: FieldConfig[]) {
        let qc: QueryCondition;
        let controlType: string;
        if (fieldConfigs && fieldConfigs.length) {
            fieldConfigs.forEach(v => {
                qc = conditions.find(c => c.fieldCode == v.labelCode);
                if (qc) {
                    controlType = this.getControlType(qc);
                    qc.value = this.filterService.setValues(controlType, v.value);
                }
            });
        }
    }

    getValue(fieldName: string) {
        const queryList = this.handler.setFilterConditions(this.listFilterConditions);
        const item = queryList.find((n: any) => n['FilterField'] === fieldName);
        if (item) {
            return item.value;
        }
        return undefined;
    }

    // 必填项初始化
    requiredListInit() {
        const requiredList = this.listFilterConditions.filter((listitem) => {
            return listitem.control.required;
        });
        if (requiredList && requiredList.length) {
            this.requiredListFilter = requiredList;
            this.canSubmit = this.canSubmitFilter(this.requiredListFilter);
        } else {
            this.requiredListFilter = [];
            this.canSubmit = true;
        }
    }

    clearFilterValue(fields: any) {
        if (fields && fields.length) {
            if (typeof fields === 'string') {
                fields = fields.split(',');
            }
            fields = fields.map(n => {
                return n.toLowerCase();
            });

            this.listFilterConditions.forEach(n => {
                if (fields.indexOf(n.fieldCode.toLowerCase()) > -1) {
                    n.value.clearValue();
                }
            });
        }
    }

    updateValues(values: { [field: string]: any }) {
        if (values && Object.keys(values)) {
            const fields = Object.keys(values);
            fields.forEach( f => {
                this.listFilterConditions.forEach(n => {
                    if (fields.indexOf(n.fieldCode.toLowerCase()) > -1) {
                        n.value['value'] = values[f];
                    }
                });
            });
        }
    }

    buildSmartHelpKey(value: string) {
        if(this.idService) {
            let prefix = '';
            if (location.hash) {
                const pathArr = location.hash.split('?');
                prefix = pathArr ? pathArr[0] : '';
            } else {
                const pathArr  = location.pathname.split('/');
                prefix = pathArr ? pathArr[pathArr.length - 1] : '';
            }
            return this.idService.encrypt(prefix + '/list-filter/' + value);
        } else {
            return 'list-filter/' + value;
        }
    }
    private conditionChangeHandler(searchEmit=true){
        const queryList = this.handler.setFilterConditions(this.listFilterConditions);
        this.conditionsChange.emit({data:JSON.stringify(queryList)});
        if(searchEmit){
            this.searchChange.emit(this.listFilterConditions);
        }
    }
    /**
     * 浮动筛选面板通过方法展开和关闭
     * @param evt 
     */
   floatFilterOpen(evt: MouseEvent){
    this.showFilter = !this.showFilter
    if (this.showFilter) {
        this.overLayService.registerMouseEvent(this.floatPanel.nativeElement, (e: any) => {           
            if (this.floatPanel.nativeElement.contains(e.target)) {
                return;
            } else {
                if (e.target.nodeName === 'SPAN' && e.target.className.indexOf('f-icon-filtrate')) {
                    return;
                }
                const cls = ['.f-datepicker-container', '.farris-timer-picker', '.farris-modal', '.f-combo-lookup', '.date-overlay-container']
                if (cls.find(k => e.target.closest(k))) {
                    return;
                }
            }
            this.showFilter = false;
            this.overLayService.destory(this.floatPanel.nativeElement);
            this.cd.detectChanges();
        });
    } else {
        this.overLayService.destory(this.floatPanel.nativeElement);
    }
   }
   toggleExpandState(){
    this.expandedState = !this.expandedState;
    this.updateFilterItemsVisibility();
   }
}
